// Fix for variant price not updating on PDP
function fixVariantPriceUpdate() {
  var variantSelections = document.querySelectorAll('[data-variant-selection]');
  if (!variantSelections.length) return;

  function getMoneyFormat(productWrapper) {
    var moneyFormat = '${{amount}}';
    try {
      var sectionData = productWrapper.querySelector('[data-section-data]');
      if (sectionData) {
        var parsed = JSON.parse(sectionData.textContent);
        if (parsed.settings && parsed.settings.money_format) {
          moneyFormat = parsed.settings.money_format;
        }
      }
    } catch (e) {}
    if (window.SHOP_MONEY_FORMAT) {
      moneyFormat = window.SHOP_MONEY_FORMAT;
    }
    return moneyFormat;
  }

  function updatePriceDisplay(pricingEl, variant, moneyFormat) {
    // Update current price
    var priceEls = pricingEl.querySelectorAll('[data-price-container] [data-price]');
    priceEls.forEach(function(el) {
      el.innerHTML = Shopify.formatMoney(variant.price, moneyFormat);
    });

    // Update compare at price
    var compareEls = pricingEl.querySelectorAll('[data-price-compare-container] [data-price-compare]');
    var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
    var compareContainer = pricingEl.querySelector('[data-price-compare-container]');

    if (compareContainer) {
      if (hasCompare) {
        compareContainer.classList.add('visible');
        compareEls.forEach(function(el) {
          el.innerHTML = Shopify.formatMoney(variant.compare_at_price, moneyFormat);
        });
      } else {
        compareContainer.classList.remove('visible');
      }
    }

    // Update sale class on price container
    var priceContainer = pricingEl.querySelector('[data-price-container]');
    if (priceContainer) {
      if (hasCompare) {
        priceContainer.classList.add('price__current--on-sale');
      } else {
        priceContainer.classList.remove('price__current--on-sale');
      }
    }

    // Ensure pricing is visible
    pricingEl.style.visibility = 'visible';
  }

  variantSelections.forEach(function(variantSelection) {
    // Determine if this is on a main product page (not quickshop/modal)
    var isMainProductPage = !!variantSelection.closest('[data-section-type="static-product"]');

    // Fix on variant change
    variantSelection.addEventListener('variant-change', function(event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;

      var productWrapper = variantSelection.closest('[data-product-wrapper]')
        || variantSelection.closest('.product__container')
        || variantSelection.closest('[data-section-type="static-product"]')
        || document;

      var pricingEl = productWrapper.querySelector('[data-product-pricing]');
      if (!pricingEl) return;

      var moneyFormat = getMoneyFormat(productWrapper);

      setTimeout(function() {
        updatePriceDisplay(pricingEl, variant, moneyFormat);

        // Update URL with variant parameter on main product page
        if (isMainProductPage && history.replaceState && !window.Shopify?.designMode) {
          var newUrl = window.location.pathname + '?variant=' + variant.id;
          history.replaceState({}, '', newUrl);
        }
      }, 50);
    });

    // Fix initial load: if no variant is pre-selected, show first available variant price
    var currentVariantAttr = variantSelection.getAttribute('variant');
    if (!currentVariantAttr || currentVariantAttr === 'not-selected') {
      var productUrl = variantSelection.getAttribute('product-url');
      if (productUrl) {
        fetch(productUrl)
          .then(function(res) { return res.json(); })
          .then(function(product) {
            // Find first available variant
            var firstAvailable = product.variants.find(function(v) { return v.available; })
              || product.variants[0];
            if (!firstAvailable) return;

            var productWrapper = variantSelection.closest('[data-product-wrapper]')
              || variantSelection.closest('.product__container')
              || variantSelection.closest('[data-section-type="static-product"]')
              || document;

            var pricingEl = productWrapper.querySelector('[data-product-pricing]');
            if (!pricingEl) return;

            var moneyFormat = getMoneyFormat(productWrapper);
            updatePriceDisplay(pricingEl, firstAvailable, moneyFormat);
          })
          .catch(function() {});
      }
    }
  });
}

// Fix for inconsistent quantity selector buttons on PDP
function fixQuantitySelectorButtons() {
  // Helper function to update minus button state
  function updateMinusButtonState(input) {
    const quantitySelector = input.closest('[data-quantity-selector]');
    if (!quantitySelector) return;
    
    const incrementValue = parseInt(input.dataset.incrementValue) || 1;
    const minusWrapper = quantitySelector.querySelector('[data-button-wrapper-minus]');
    if (!minusWrapper) return;
    
    const currentValue = parseInt(input.value) || incrementValue;
    if (currentValue <= incrementValue) {
      minusWrapper.classList.add('quantity-selector__button-wrapper--disabled');
    } else {
      minusWrapper.classList.remove('quantity-selector__button-wrapper--disabled');
    }
  }
  
  // Handle manual input changes to keep minus button state correct
  document.addEventListener('input', function(e) {
    const input = e.target;
    if (input && input.hasAttribute('data-quantity-input')) {
      // Validate and fix the input value
      const incrementValue = parseInt(input.dataset.incrementValue) || 1;
      let value = parseInt(input.value);
      
      if (isNaN(value) || value < incrementValue) {
        // If invalid, set to minimum after a short delay (allows user to finish typing)
        setTimeout(function() {
          if (isNaN(parseInt(input.value)) || parseInt(input.value) < incrementValue) {
            input.value = incrementValue;
            updateMinusButtonState(input);
          }
        }, 1000);
      } else {
        // Update minus button state immediately for valid input
        updateMinusButtonState(input);
      }
    }
  }, true);
  
  // Use event delegation as a reliable fallback that works even if QuantitySelector fails
  document.addEventListener('click', function(e) {
    // Check if click is on a quantity button
    const button = e.target.closest('[data-quantity-plus], [data-quantity-minus]');
    if (!button) return;
    
    const quantitySelector = button.closest('[data-quantity-selector]');
    if (!quantitySelector) return;
    
    const input = quantitySelector.querySelector('[data-quantity-input]');
    if (!input) return;
    
    const isPlus = button.hasAttribute('data-quantity-plus');
    const isMinus = button.hasAttribute('data-quantity-minus');
    const incrementValue = parseInt(input.dataset.incrementValue) || 1;
    const minusWrapper = quantitySelector.querySelector('[data-button-wrapper-minus]');
    
    // Check if minus button is disabled
    if (isMinus && minusWrapper && minusWrapper.classList.contains('quantity-selector__button-wrapper--disabled')) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    
    // Get current value - handle manual input better
    // Parse the input value, ensuring it's a valid number
    let currentValue = parseInt(input.value);
    // If input is empty, invalid, or NaN, use incrementValue as minimum
    if (isNaN(currentValue) || currentValue < incrementValue) {
      currentValue = incrementValue;
    }
    
    // Calculate new value
    let newValue;
    if (isPlus) {
      newValue = currentValue + incrementValue;
    } else if (isMinus) {
      newValue = Math.max(incrementValue, currentValue - incrementValue);
    } else {
      return;
    }
    
    // Always update the value when button is clicked
    // Use a small delay to let theme's handler run first, then ensure our change applies
    setTimeout(function() {
      // Re-read the value in case theme handler changed it
      let actualValue = parseInt(input.value);
      if (isNaN(actualValue) || actualValue < incrementValue) {
        actualValue = incrementValue;
      }
      
      // Only update if the value hasn't been changed to what we expect
      // This handles cases where theme handler worked, or user manually edited
      if (actualValue !== newValue) {
        // If the value is different from what we calculated, use the actual value as base
        // This handles manual input scenarios
        if (isPlus) {
          newValue = actualValue + incrementValue;
        } else if (isMinus) {
          newValue = Math.max(incrementValue, actualValue - incrementValue);
        }
        
        input.value = newValue;
      }
      
      // Always update minus button state based on final value
      updateMinusButtonState(input);
      
      // Trigger events to ensure other handlers are notified
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }, 50);
  }, true); // Use capture phase
}

document.addEventListener("DOMContentLoaded", () => {
  fixQuantitySelectorButtons();
  fixVariantPriceUpdate();
});

document.addEventListener("DOMContentLoaded", () => {
  document.body.classList.add("c-cartDrawerA");
  enableCartButton();
  addMorePaymentMethods();
  revealCheckoutButtons();
});

function enableCartButton() {
  var cartButton = document.querySelector('.site-header-cart--button');
  if (cartButton) {
    cartButton.style.pointerEvents = '';
    cartButton.style.opacity = '';
    cartButton.style.cursor = '';
    cartButton.removeAttribute('aria-disabled');
    cartButton.removeAttribute('data-cart-button-disabled');
  }
}

// Reveal additional checkout buttons only after Shopify iframes load
function revealCheckoutButtons() {
  var wrapper = document.querySelector('.c-cart-drawer-additional-checkout-buttons');
  if (!wrapper) return;

  // Check if buttons are already rendered
  var iframes = wrapper.querySelectorAll('iframe');
  if (iframes.length > 0) {
    wrapper.classList.add('c-checkout-loaded');
    return;
  }

  // Watch for iframes to appear inside the container
  var observer = new MutationObserver(function() {
    var hasIframes = wrapper.querySelectorAll('iframe').length > 0;
    if (hasIframes) {
      wrapper.classList.add('c-checkout-loaded');
      observer.disconnect();
    }
  });

  observer.observe(wrapper, { childList: true, subtree: true });

  // Fallback: reveal after 4s regardless
  setTimeout(function() {
    wrapper.classList.add('c-checkout-loaded');
    observer.disconnect();
  }, 4000);
}

function addMorePaymentMethods() {
  const wrapper = document.querySelector('.c-cart-drawer-additional-checkout-buttons');
  if (!wrapper) return;

  const dynamic = wrapper.querySelector('[data-shopify="dynamic-checkout-cart"]');
  if (!dynamic) return;

  const host = dynamic.querySelector('shopify-accelerated-checkout-cart');
  if (!host) return;

  const attr = host.getAttribute('wallet-configs');
  if (!attr) return;

  let configs;
  try {
    configs = JSON.parse(attr);
  } catch (e) {
    console.warn('Could not parse wallet-configs', e);
    return;
  }

  const walletCount = configs.length;
  if (walletCount < 4) return; // only do the toggle version if 4+ wallets

  // Prepare wrapper for animation
  wrapper.classList.add('c-wallet-toggle'); // starts in "closed" state (no is-open)

  // Create toggle button
  const toggleBtn = document.createElement('button');
  toggleBtn.type = 'button';
  toggleBtn.className = 'btn btn--secondary c-more-payment-methods';
  toggleBtn.textContent = 'More payment methods';

  // Insert above the wallets
  wrapper.insertAdjacentElement('beforebegin', toggleBtn);

  let isOpen = false;

  toggleBtn.addEventListener('click', function () {
    isOpen = !isOpen;

    if (isOpen) {
      wrapper.classList.add('is-open');               // slide in from bottom
      toggleBtn.textContent = 'Hide payment methods'; // optional label
    } else {
      wrapper.classList.remove('is-open');            // slide out / collapse
      toggleBtn.textContent = 'More payment methods';
    }
  });
}


/* =========================================================
   Trending Collections – Tabs + Dots
   The theme's SectionManager uses IntersectionObserver (lazy:true) to init
   dynamic-featured-collection sections. This fails for panels hidden via
   position:absolute/opacity:0 or inside a display:none ancestor (AB test).
   Fix: for any panel where Flickity hasn't been created by the theme, we
   dispatch a synthetic shopify:section:load event. The SectionManager handles
   it by calling _createInstance → FeaturedCollection (Flickity + ProductGridItem).
   ========================================================= */
(function () {

  /* Check if Flickity is initialised on a carousel element via its DOM class */
  function isFlickityReady(carousel) {
    return carousel.classList.contains('flickity-enabled');
  }

  /* Force the theme's SectionManager to create FeaturedCollection for a panel.
     shopify:section:load → _onSectionEvent → _createInstance(sectionId, el)
     which inits FeaturedCollection (Flickity + ProductGridItem + hover). */
  function forceThemeInit(panel) {
    var sectionId = panel.id.replace('shopify-section-', '');
    var evt = new CustomEvent('shopify:section:load', {
      bubbles: true,
      detail: { sectionId: sectionId }
    });
    panel.dispatchEvent(evt);
  }

  /* Build pagination dots from the Flickity DOM structure.
     The theme's Flickity is inside a webpack closure so the instance isn't
     accessible via window.Flickity or $.data(). Instead we:
     1. Count pages from visible vs total cells (groupCells:true)
     2. Track the current page via jQuery 'select.flickity' events
     3. Navigate via prev/next button clicks */
  function initDots(panel) {
    var dotsWrap = panel.querySelector('[data-c-trending-dots]');
    if (!dotsWrap) return;
    var carousel = panel.querySelector('[data-content]');
    if (!carousel) return;

    var attempts = 0;
    function tryBuildDots() {
      if (!isFlickityReady(carousel)) {
        attempts++;
        if (attempts < 30) setTimeout(tryBuildDots, 200);
        return;
      }

      var cells = carousel.querySelectorAll('.productgrid--item');
      var selectedCells = carousel.querySelectorAll('.productgrid--item.is-selected');
      var cellsPerPage = selectedCells.length || 1;
      var pageCount = Math.ceil(cells.length / cellsPerPage);

      if (pageCount <= 1) return;

      var prevBtn = carousel.querySelector('.flickity-prev-next-button.previous');
      var nextBtn = carousel.querySelector('.flickity-prev-next-button.next');
      var currentPage = 0;

      dotsWrap.innerHTML = '';
      for (var i = 0; i < pageCount; i++) {
        var dot = document.createElement('button');
        dot.className = 'c-trending-dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        if (i === 0) dot.classList.add('c-trending-dot--active');
        (function (idx) {
          dot.addEventListener('click', function () {
            var diff = idx - currentPage;
            if (diff === 0) return;
            var btn = diff > 0 ? nextBtn : prevBtn;
            if (!btn) return;
            for (var c = 0; c < Math.abs(diff); c++) btn.click();
          });
        })(i);
        dotsWrap.appendChild(dot);
      }

      function updateDots(index) {
        if (index < 0 || index >= pageCount) return;
        currentPage = index;
        var dots = dotsWrap.querySelectorAll('.c-trending-dot');
        dots.forEach(function (d, j) {
          d.classList.toggle('c-trending-dot--active', j === index);
        });
      }

      /* Track page changes via Flickity's jQuery events */
      if (typeof $ !== 'undefined') {
        $(carousel).off('select.flickity.ctrending').on('select.flickity.ctrending', function (_e, index) {
          updateDots(index);
        });
      }

      /* Backup: observe class changes on cells to detect page transitions */
      var cellsArray = Array.from(cells);
      var observer = new MutationObserver(function () {
        var sel = carousel.querySelectorAll('.productgrid--item.is-selected');
        if (sel.length === 0) return;
        var firstIdx = cellsArray.indexOf(sel[0]);
        var page = Math.floor(firstIdx / cellsPerPage);
        if (page !== currentPage) updateDots(page);
      });
      cells.forEach(function (cell) {
        observer.observe(cell, { attributes: true, attributeFilter: ['class'] });
      });
    }
    tryBuildDots();
  }

  /* Ensure a panel has a fully initialised FeaturedCollection (Flickity + ProductGridItem).
     If not, dispatch shopify:section:load to make the theme create it. */
  function ensurePanel(panel) {
    var carousel = panel.querySelector('[data-content]');
    if (!carousel) return;
    if (!isFlickityReady(carousel)) {
      forceThemeInit(panel);
    }
  }

  /* Activate a panel on tab click: ensure init, resize, reset to slide 0, build dots */
  function activatePanel(panel) {
    var carousel = panel.querySelector('[data-content]');
    if (!carousel) return;

    ensurePanel(panel);

    /* Poll for Flickity via DOM, then reset to slide 0 + build dots */
    var attempts = 0;
    function tryActivate() {
      if (!isFlickityReady(carousel)) {
        attempts++;
        if (attempts < 30) setTimeout(tryActivate, 200);
        return;
      }
      /* Reset to first slide via prev button */
      var prevBtn = carousel.querySelector('.flickity-prev-next-button.previous');
      if (prevBtn) {
        for (var i = 0; i < 20; i++) prevBtn.click();
      }
      initDots(panel);
    }
    setTimeout(tryActivate, 100);
  }

  /* Init all panels in a root: force theme init where missing, resize all,
     then build dots for the active panel. */
  function initAllPanels(root) {
    var panels = root.querySelectorAll('[data-c-trending-panel]');
    panels.forEach(function (panel) { ensurePanel(panel); });

    /* Wait for Flickity to be created by the theme, then build dots */
    setTimeout(function () {
      var activePanel = root.querySelector('.c-trending-panel--active');
      if (activePanel) initDots(activePanel);
    }, 500);
  }

  var trendingRoots = [];

  function bindTrendingRoot(root) {
    if (root._trendingBound) return;
    root._trendingBound = true;

    var tabs   = Array.from(root.querySelectorAll('[data-c-trending-tab]'));
    var panels = Array.from(root.querySelectorAll('[data-c-trending-panel]'));

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var targetId = this.getAttribute('data-c-trending-tab');

        tabs.forEach(function (t) {
          t.classList.remove('c-trending-tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function (p) {
          p.classList.remove('c-trending-panel--active');
        });

        this.classList.add('c-trending-tab--active');
        this.setAttribute('aria-selected', 'true');

        var targetPanel = root.querySelector('[data-c-trending-panel="' + targetId + '"]');
        if (!targetPanel) return;

        targetPanel.classList.add('c-trending-panel--active');
        activatePanel(targetPanel);
      });
    });
  }

  /* Called at DOMContentLoaded and ig:ready */
  function scheduleInit() {
    trendingRoots.forEach(function (root) {
      setTimeout(function () { initAllPanels(root); }, 800);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-c-trending-root]').forEach(function (root) {
      trendingRoots.push(root);
      bindTrendingRoot(root);
    });
    scheduleInit();
  });

  /* ig:ready fires after Intelligems adds the AB test body class.
     Section transitions from display:none → visible. Re-init everything. */
  window.addEventListener('ig:ready', scheduleInit);

})();

/* Total Order Savings – Cart Drawer */
/* Keeps the savings amount + percentage bar in sync with the cart after AJAX updates.
   Initial values are server-rendered in Liquid; this only recalculates on cart change.
   All copy is read from data-* attributes rendered by Liquid (no static values here). */
(function () {
  var productCache = {};

  function getCurrency() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }
    return 'GBP';
  }

  function formatMoney(cents, currency) {
    try {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: currency });
    } catch (e) {
      return currency + ' ' + (cents / 100).toFixed(2);
    }
  }

  function fetchProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
    return productCache[handle];
  }

  function updateSavings() {
    var el = document.querySelector('[data-cart-savings]');
    if (!el) return;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var handles = items.map(function (i) { return i.handle; });
        var unique = handles.filter(function (h, idx) { return handles.indexOf(h) === idx; });

        return Promise.all(unique.map(fetchProduct)).then(function (products) {
          var map = {};
          products.forEach(function (p) { if (p) map[p.handle] = p; });

          var rrpTotal = 0;
          items.forEach(function (item) {
            var product = map[item.handle];
            var variant = product ? product.variants.find(function (v) { return v.id === item.variant_id; }) : null;
            var compare = variant ? variant.compare_at_price : null;
            if (compare && compare > item.price) {
              rrpTotal += compare * item.quantity;
            } else {
              rrpTotal += item.original_line_price;
            }
          });

          var savings = Math.max(rrpTotal - cart.total_price, 0);
          var percentage = rrpTotal > 0 ? Math.floor((savings * 100) / rrpTotal) : 0;
          var currency = getCurrency();

          el.setAttribute('data-has-savings', savings > 0 ? 'true' : 'false');

          var amountEl = el.querySelector('[data-cart-savings-amount]');
          if (amountEl) amountEl.textContent = formatMoney(savings, currency);

          var pctEl = el.querySelector('[data-cart-savings-percentage]');
          if (pctEl) pctEl.textContent = percentage;

          var barEl = el.querySelector('[data-cart-savings-bar]');
          if (barEl) barEl.style.width = percentage + '%';
        });
      })
      .catch(function () { /* leave server-rendered values in place */ });
  }

  function observeSubtotal() {
    var subtotal = document.querySelector('[data-cart-total]');
    if (!subtotal || subtotal.dataset.cSavingsObserved) return;
    subtotal.dataset.cSavingsObserved = 'true';
    var observer = new MutationObserver(function () { updateSavings(); });
    observer.observe(subtotal, { childList: true, characterData: true, subtree: true });
  }

  function init() {
    observeSubtotal();
    updateSavings();
  }

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('ig:ready', init);
})();

/* =========================================================
   V_B2D_CART_53 | "Customers Usually Start Here" Empty Cart Discovery Grid
   CONCLUDED: Var A winner (now permanent) — runs for every visitor.
   Moves the schema-driven grid from sections/c-cart-discovery-grid.liquid into
   the cart drawer's content column (as a sibling of #c-cart-items, so the
   drawer's own innerHTML re-renders can never wipe it) and marks the drawer as
   empty / filled so CSS can reveal the grid.
   Carts with items are untouched. All copy, colours and spacing live in the
   section schema; nothing is set from here.
   ========================================================= */
(function () {
  'use strict';

  var EMPTY_CLASS = 'c-cartDiscovery-empty';

  var grid = null;
  var content = null;
  var items = null;
  var observer = null;
  var started = false;
  var viewFired = false;
  var pricesRequested = false;

  function fireEvent(name, detail) {
    try {
      document.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
    } catch (e) {}
  }

  // True while the drawer is showing its empty state. The drawer writes
  // .c-empty-cart into #c-cart-items whenever the cart has no line items.
  function isEmptyState() {
    return !!(items && items.querySelector('.c-empty-cart'));
  }

  function place() {
    if (!grid || !content || !items) return;
    // Sit directly after the items list so the grid follows the
    // "Your cart is empty" message and scrolls with the drawer content.
    if (grid.previousElementSibling !== items || grid.parentNode !== content) {
      items.insertAdjacentElement('afterend', grid);
    }
  }

  function paintPrice(node, amount) {
    // Guard against a redirect or error page being pasted into a tile.
    if (!amount || amount.length > 24 || !/\d/.test(amount)) return;
    var prefix = node.getAttribute('data-price-prefix') || '';
    node.textContent = (prefix ? prefix + ' ' + amount : amount).trim();
  }

  // The price Liquid renders is a lower bound: a section can only see the first
  // 50 products of a collection. templates/collection.c-cart53-price.liquid
  // returns the true minimum because ?sort_by=price-ascending is applied across
  // the whole collection server-side before paginating. Fetched once per
  // collection per session, and only once the grid is actually shown — Control
  // never requests it.
  function resolveExactPrices() {
    if (pricesRequested || !grid) return;
    pricesRequested = true;

    var nodes = grid.querySelectorAll('[data-c-cart53-price][data-price-url]');

    Array.prototype.forEach.call(nodes, function (node) {
      var url = node.getAttribute('data-price-url');
      if (!url) return;
      var cacheKey = 'c-cart53-price:' + url;

      var cached = null;
      try { cached = window.sessionStorage.getItem(cacheKey); } catch (e) {}
      if (cached) {
        paintPrice(node, cached);
        return;
      }

      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (response) { return response.ok ? response.text() : ''; })
        .then(function (text) {
          var amount = String(text || '').trim();
          if (!amount) return;
          try { window.sessionStorage.setItem(cacheKey, amount); } catch (e) {}
          paintPrice(node, amount);
        })
        .catch(function () {});
    });
  }

  function sync() {
    if (!content) return;

    var empty = isEmptyState();
    content.classList.toggle(EMPTY_CLASS, empty);

    if (empty) {
      place();
      resolveExactPrices();
      if (!viewFired) {
        viewFired = true;
        fireEvent('cart_discovery_view', { test: 'V_B2D_CART_53' });
      }
    }
  }

  function bindTileClicks() {
    grid.addEventListener('click', function (event) {
      var tile = event.target.closest('[data-c-cart53-tile]');
      if (!tile) return;
      fireEvent('cart_discovery_click', {
        test: 'V_B2D_CART_53',
        title: tile.getAttribute('data-tile-title') || '',
        url: tile.getAttribute('href') || ''
      });
    });
  }

  function init() {
    if (started) return;

    grid = document.querySelector('[data-c-cart53]');
    content = document.querySelector('.c-cart-drawer-content');
    items = document.getElementById('c-cart-items');
    // No drawer on the dedicated cart page, and no grid if every tile is
    // unconfigured — either way there is nothing to do.
    if (!grid || !content || !items) return;

    started = true;
    place();
    bindTileClicks();
    sync();

    // The drawer replaces #c-cart-items' innerHTML on every cart render, which
    // is what flips the empty / filled state.
    observer = new MutationObserver(sync);
    observer.observe(items, { childList: true, subtree: true });

    // Re-check when the drawer opens and after any cart mutation, so the state
    // is correct even if the drawer renders before we are watching.
    ['cartcount:update', 'product:add-to-cart', 'cart:updated', 'cart:change', 'cart:item-added', 'cart:needs:update']
      .forEach(function (evt) {
        window.addEventListener(evt, sync);
        document.addEventListener(evt, sync);
      });

    var overlay = document.getElementById('c-cart-drawer-overlay');
    if (overlay) {
      new MutationObserver(sync).observe(overlay, {
        attributes: true,
        attributeFilter: ['class', 'style']
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 0); });
  window.addEventListener('ig:ready', function () { setTimeout(init, 0); });
})();

/* =========================================================
   V_B2D_PDP_57 | "Most Gifted" Badge + Gift Context Block on PDP
   CONCLUDED: Var A winner (now permanent) — runs for every visitor.
   Moves the gift-context badge rendered by
   snippets/c-pdp57-most-gifted-badge.liquid from its hidden holder at the end
   of the body to the slot directly above the product page title.
   Copy, colours and spacing all come from Liquid (theme settings), so there are
   no static values here. Only the main product page title is targeted: it is
   the one .product-title that is an <h1>, so quickshop modals, featured
   products and product cards (which use <h2>) can never be matched.
   ========================================================= */
(function () {
  'use strict';

  var BADGE_SELECTOR = '[data-c-pdp57-badge]';
  var PLACED_ATTR = 'data-c-pdp57-placed';
  var TITLE_SELECTOR = '[data-product-details] h1.product-title';

  // Kept so the badge can be restored if the theme re-renders the product
  // section (Theme Customizer, combined listings), which would destroy the node
  // once it lives inside that section.
  var cached = null;

  function getBadge() {
    var existing = document.querySelector(BADGE_SELECTOR);
    if (existing) {
      if (!cached) cached = existing.cloneNode(true);
      return existing;
    }
    return cached ? cached.cloneNode(true) : null;
  }

  function findTitle() {
    var titles = document.querySelectorAll(TITLE_SELECTOR);
    for (var i = 0; i < titles.length; i++) {
      if (titles[i].closest('[data-product-quickshop]')) continue;
      return titles[i];
    }
    return null;
  }

  function place() {
    var title = findTitle();
    if (!title) return;

    var previous = title.previousElementSibling;
    if (previous && previous.hasAttribute(PLACED_ATTR)) return;

    var badge = getBadge();
    if (!badge) return;

    title.parentNode.insertBefore(badge, title);
    badge.removeAttribute('hidden');
    badge.setAttribute(PLACED_ATTR, '');
  }

  function schedule() {
    setTimeout(place, 0);
  }

  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('ig:ready', schedule);
  document.addEventListener('shopify:section:load', schedule);
})();
